/*
 * @Author: 李明明
 * @Date: 2022-07-28 14:04:37
 * @LastEditTime: 2024-04-22 16:13:47
 * @LastEditors: 李明明
 * @Description:
 * @FilePath: /ykt-micro-main/src/utils/sso-login.js
 * 代码版权方：'政府采购信息网'
 */
import store from "@/store/index.js";
import * as cookie from "@/utils/cookie.js";

let href = encodeURIComponent(window.location.href);
let origin = encodeURIComponent(window.location.origin);

function toPage(url) {
  // 正式
  let _ = url("");
  let host = window.location.host;
  // 测试
  if (host.indexOf("test") !== -1) {
    _ = url("test");
  }
  // 开发
  if (host.indexOf("dev") !== -1) {
    _ = url("dev");
  }
  window.location.href = _;
}
// 登录
export const login = () => {
  cookie.clearCookie("userInfo");
  cookie.clearCookie("token");
  let url = (r) =>
    `https://${r}sso.caigou2003.com/#/login?returnUrl=${encodeURIComponent(
      location.href
    )}`;
  toPage(url);
};
// 登出
export const signOut = () => {
  let url = (r) =>
    `https://${r}sso.caigou2003.com/#/signOut?returnUrl=${origin}`;
  toPage(url);
};
// 修改密码
export const modifyPwd = () => {
  let url = (r) =>
    `https://${r}sso.caigou2003.com/#/modifyPwd?returnUrl=${encodeURIComponent(
      location.href
    )}`;
  toPage(url);
};
